module.exports = __webpack_public_path__ + "static/media/rangqi_03.141f7c93.png";